import React, { useEffect, useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import { themeService } from "../NotificationStripNav/ThemeService";
import { Theme } from "../Models/CustomSiteConfigModel";
import { TablePanelModel } from "../Models/TablePanelModel";

import "./TablePanel.css";

const TablePanel: React.FC<{ blok: TablePanelModel }> = ({ blok }) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div
      className="table-panel"
      {...storyblokEditable(blok)}
      style={{ color: theme?.textColor, backgroundColor: theme?.panelColour }}
    >
      <div className="container">
        <div className="title">{blok.title}</div>
        <div className="feature-text-container">
          <div className="table">
            <div
              className="row header"
              style={{ backgroundColor: theme?.tableHeaderColor }}
            >
              {blok.table?.thead.map((header) => (
                <div
                  className="cell"
                  key={`table-panel-header-${header?.value}`}
                >
                  {header?.value}
                </div>
              ))}
            </div>
            {blok.table?.tbody.map((tbody, rowIndex) => {
              return (
                <div
                  {...storyblokEditable(blok)}
                  className="download-comp row"
                  style={{
                    backgroundColor:
                      rowIndex % 2 === 0
                        ? theme?.tableEvenColumnsColor
                        : theme?.tableOddColumnsColor,
                  }}
                  key={`table-panel-body-${rowIndex}`}
                >
                  {tbody.body.map((body, columnIndex) => (
                    <div
                      // className="cell text-left"
                      className={`cell ${columnIndex === 0 ? "text-left" : ""}`}
                      key={`table-panel-body-${rowIndex}-${columnIndex}-${body?.value}`}
                    >
                      {body?.value}
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablePanel;
